import { useEffect, useRef, useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { CartIcon, MenuIcon, path, SearchIcon, setDefaultAll, Sloading, slugify, UserIcon } from '../../base'
import { useDispatch, useSelector } from 'react-redux'
import SideBar from './SideBar'

function Header() {
  const [showProfileDropDown, setShowProfileDropDown] = useState(false)
  const [showCategoryDropDown, setShowCategoryDropDown] = useState(false)
  const [showSideBar, setShowSideBar] = useState(false)
  const profileRef = useRef(null)
  const categoryRef = useRef(null)
  const navigate = useNavigate()
  const { user, app_loading, cart_total_item } = useSelector((state) => state.appSlice)
  const category_options = useSelector((state) => state.appSlice.category_options)
  const dispatch = useDispatch()
  
  // hide profile / category dropdown when click outside
  function hideDropDownOnClickOutSide(e) {
    if (profileRef.current && !profileRef.current.contains(e.target)) {
      setShowProfileDropDown(false)
    }
    if (categoryRef.current && !categoryRef.current.contains(e.target)) {
      setShowCategoryDropDown(false)
    }
  }

  // hide dropdown at page back
  function hideDropDownOnPageBack() {
    setShowProfileDropDown(false)
    setShowCategoryDropDown(false)
  }

  // logout the user
  function logout() {
    setShowProfileDropDown(false)
    setDefaultAll(dispatch, true)
  }

  // add / remove the evnet for hide dropdowns 
  useEffect(() => {
    document.addEventListener('click', hideDropDownOnClickOutSide)
    window.addEventListener('popstate', hideDropDownOnPageBack)
    return () => {
      document.removeEventListener('click', hideDropDownOnClickOutSide)
      window.removeEventListener('popstate', hideDropDownOnPageBack)
    }
  }, [])



  return (
    <header>
      <div className='navBar position-relative'>
        <span className='iconSpan d-flex d-md-none' onClick={() => setShowSideBar(true)}><MenuIcon /></span>
        <div className='logoSide d-flex gap-4'>
          <span className='d-none d-md-flex iconSpan' onClick={() => setShowSideBar(true)}><MenuIcon /></span>
          <div className='logo' onClick={() => navigate(path.home)}>
            Ahilya<span>Handlooms</span>
          </div>
        </div>
        <div className='otherSide d-flex gap-3' style={{ alignItems: 'center' }}>
          <div className='navLinks'>
            <div className='link'><NavLink to={path.home} className='h6 d-none d-lg-flex'>Home</NavLink></div>
            <div className='link productNavLink ' ref={categoryRef} onClick={() => setShowCategoryDropDown(!showCategoryDropDown)}><a className='h6 d-none d-lg-flex'>Products</a>
              <div className={`categoryDropdown d-none d-lg-block ${showCategoryDropDown ? 'show' : ''}`}>
                {
                  category_options && category_options.map((item, index) => {
                    return (
                      <div key={index}>
                        <div className='h6 link' onClick={() => navigate(`/p/shop/all/category/${slugify(item)}/products/`)}>{item === 'all' ? 'All Category Products' : item}</div> <hr className='mt-0 mb-0' />
                      </div>
                    )
                  })
                }

              </div>
            </div>
            <div className='link'><NavLink to={path.all_shop} className='h6 d-none d-lg-flex'>Shops</NavLink></div>
            <div className='link'><NavLink to={path.all_order} className='h6 d-none d-lg-flex'>Order</NavLink></div>
            <div className='link'><NavLink to={path.about} className='h6 d-none d-lg-flex'>About</NavLink></div>
            <div className='link'><NavLink to={path.cart} className='h6 d-none d-lg-flex iconSpan position-relative'><CartIcon /><span className='cartTotalItem smallText pcolor'>{cart_total_item}</span></NavLink></div>
            <div className='d-flex gap-4 userSide'>
              {
                app_loading ? <Sloading/> :
                  user === null ?
                    <button className='primaryButton' style={{padding : '3px 15px'}}  onClick={() => navigate(path.login_user)}>Login</button> :
                    <>
                      <span className='iconSpan d-none d-md-flex' onClick={() => navigate(path.product_search)}><SearchIcon /></span>
                      <div className='profile'>
                        <span ref={profileRef} className='iconSpan' onClick={() => setShowProfileDropDown(!showProfileDropDown)}><UserIcon /></span>
                        <div className={`${showProfileDropDown && 'show'} profileDropdown`}>
                          <div className='link h6' onClick={() => navigate(path.user_profile)}>Profile</div> <hr className='borderBottom' />
                          <div className='link h6' onClick={() => navigate(path.all_address)}>Address</div> <hr className='borderBottom' />
                          <div className='link h6' onClick={() => navigate(path.wishlist)}>Wish List</div><hr className='borderBottom' />
                          <div className='link h6' onClick={() => navigate(path.all_order)}>My Orders</div><hr className='borderBottom' />
                          <div className='link h6' onClick={() => logout()}>Log Out</div>
                        </div>
                      </div>
                    </>
              }
            </div>
          </div>


        </div>
      </div>

      <SideBar show={showSideBar ? 'show' : ''} setShowSideBar={setShowSideBar} />
    </header>
  )
}

export default Header